import { getDateString } from 'helpers/getDateString';

export const getAuthorDetails = ({
  author,
  authorTitle,
  authorCompany,
}: {
  author?: string;
  authorTitle?: string;
  authorCompany?: string;
}): string => {
  if (!author) return '';

  let details = author;
  if (authorTitle) details = `${details}, ${authorTitle}`;
  if (authorCompany) details = `${details}, ${authorCompany}`;
  return details;
};

export const getDetails = ({
  author,
  authorTitle,
  authorCompany,
  date,
}: {
  author?: string;
  authorTitle?: string;
  authorCompany?: string;
  date?: Date;
}) => {
  const authorDetails = getAuthorDetails({ author, authorTitle, authorCompany });

  if (!authorDetails && !date) return '';
  let details;
  if (authorDetails) details = `by ${authorDetails}`;
  if (date && !authorDetails) details = `${getDateString(date, 'MMM Do YYYY')}`;
  if (authorDetails && date) details = `${details} | ${getDateString(date, 'MMM Do YYYY')}`;

  return details;
};
